import React, { ReactNode, useState } from 'react';

interface Tab {
	id: string;
	label: string;
	content: ReactNode;
	disabled?: boolean;
}

interface TabsProps {
	tabs: Tab[];
}
function classNames(...classes: string[]) {
	return classes.filter(Boolean).join(' ');
}

const HomeTabs: React.FC<TabsProps> = ({ tabs }) => {
	const [activeTab, setActiveTab] = useState(tabs[0].id);

	return (
		<div>
			<div className="flex space-x-0 mb-4 pb-3 overflow-x-auto">
				{tabs.map((tab) => (
					<button
						key={tab.id}
						disabled={tab.disabled}
						className={classNames(
							activeTab === tab.id
								? 'text-white bg-[#106df6]'
								: tab.disabled
									? 'bg-gray-100 text-gray-400 border border-gray-300'
									: 'text-gray-500 border border-gray-300 shadow-sm',
							'rounded-0 px-2 py-1 text-xs font-medium whitespace-nowrap'
						)}
						onClick={() => setActiveTab(tab.id)}
					>
						{tab.label}
					</button>
				))}
			</div>
			<div className="py-4">
				{tabs.map((tab) => (
					<div key={tab.id} className={activeTab === tab.id ? '' : 'hidden'}>
						{tab.content}
					</div>
				))}
			</div>
		</div>
	);
};

export default HomeTabs;
